import React from 'react';

import { CONTAINER_ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { LoadablePaint } from '@confluence/loadable';

const SpaceSettingsContentStateRouteComponent = LoadablePaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-SpaceSettingsContentStateRouteComponent" */ './SpaceSettingsContentStateRouteComponent.tsx'
		),
});

export const SpaceSettingsContentStateRoute: {
	({
		params: { spaceKey },
	}: {
		params: {
			spaceKey: any;
		};
	}): React.JSX.Element;
	NAVIGATION_PARAMS({
		name,
		params: { spaceKey },
	}: {
		name: any;
		params: {
			spaceKey: any;
		};
	}): {
		Screen: {
			screenEvent: {
				name: string;
				id: any;
			};
			pageState: {
				spaceKey: any;
				routeName: any;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: any;
			disableMinWidth: boolean;
		};
	};
} = ({
	params: { spaceKey },
}: {
	params: {
		spaceKey: any;
	};
}): React.JSX.Element => <SpaceSettingsContentStateRouteComponent spaceKey={spaceKey} />;

SpaceSettingsContentStateRoute.NAVIGATION_PARAMS = ({
	name,
	params: { spaceKey },
}: {
	name: any;
	params: {
		spaceKey: any;
	};
}): {
	Screen: {
		screenEvent: {
			name: string;
			id: any;
		};
		pageState: {
			spaceKey: any;
			routeName: any;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: any;
		disableMinWidth: boolean;
	};
} => ({
	Screen: {
		screenEvent: { name: 'spaceSettingsContentState', id: spaceKey },
		pageState: { spaceKey, routeName: name },
	},
	MainLayout: {
		navView: CONTAINER_ADMIN_HOME_ID,
		spaceKey,
		disableMinWidth: true,
	},
});
